import React, { useEffect, useState, createContext } from 'react';

export const viewportSizeContext = createContext({});

export const ViewportSizeProvider = ({ children }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 769);

    const updateWindowResize = () => {
        setIsMobile(window.innerWidth < 769);
    };

    useEffect(() => {
        window.addEventListener('resize', updateWindowResize);

        return () => window.removeEventListener('resize', updateWindowResize);
    }, []);

    return <viewportSizeContext.Provider value={isMobile}>{children}</viewportSizeContext.Provider>;
};
